import { Fragment, ReactNode } from 'react';

import HeadTitle from '@/components/ui/custom/HeadTitle';
import Layout from '@/components/template/Layout';
import useAuth from '@/data/hook/useAuth';
import { UserTypeEnum } from '@/models/User';
import AdminDashboardView from './AdminDashboardView';
import StudentDashboardViewSwitcher from './StudentDashboardViewSwitcher';
import TeacherDashboardViewSwitcher from './TeacherDashboardViewSwitcher';

const dashboardByRole: Partial<Record<UserTypeEnum, ReactNode>> = {
  [UserTypeEnum.STUDENT]: <StudentDashboardViewSwitcher />,
  [UserTypeEnum.SUPER_ADMIN]: (
    <Layout>
      <AdminDashboardView />
    </Layout>
  ),
  [UserTypeEnum.UNIT_ADMIN]: (
    <Layout>
      <AdminDashboardView />
    </Layout>
  ),
  [UserTypeEnum.TEACHER]: (
    <Layout>
      <TeacherDashboardViewSwitcher />
    </Layout>
  ),
};

export default function DashboardPage() {
  const { user } = useAuth();

  const dashboard = (user?.userType && dashboardByRole[user.userType]) ?? (
    <Layout>
      <Fragment />
    </Layout>
  );

  return (
    <Fragment>
      <HeadTitle />
      {dashboard}
    </Fragment>
  );
}
